<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <span>Atendimentos em Andamento?</span>
        <toogleswitch
          style="margin-top: 10px;"
          v-model="statusValue"
          label="Atendimento em Andamento"
          @change="onToggleChange"
        />
      <SearchCollapse :expanded="true" title="Dados Gerais">
        <NxInputName @update:value="handleInputUpdate('name', $event)" />
        <NxInputClientWApp @update:value="handleInputUpdate('identifier', $event)" />
        <NxInputProtocolsWApp @update:value="handleInputUpdateArray('protocols', $event)" />
      </SearchCollapse>
      <SearchCollapse title="Instituição">
        <NxSelectPAAtendimento @update:value="handleSelectUpdate('deptoId', $event)" />
      </SearchCollapse>
      <SearchCollapse title="Responsável">
        <NxSelectResponsavelAtendimento @update:value="handleSelectUpdate('operatorId', $event)" />
      </SearchCollapse>
      <SearchCollapse title="Geral">
        <div>
          <NxInputDateRangeAtendimento
            :limitToFifteenDays="true"
            label="Período de Referência:"
            @update:InitialValue="handleInputDateUpdate('centralStartDate', $event, false)"
            @update:FinalValue="handleInputDateUpdate('centralEndDate', $event, false)"
          />
          <div class="mb-2">
            <label class="mb-1 d-block">Origem do atendimento:</label>
            <b-form-radio-group
              v-model="form.origemAtendimento"
              :options="origemOptions"
              buttons
              button-variant="outline-secondary"
              size="sm"
            />
          </div>
          <NxSelectTipoFinalizacao @update:value="handleSelectUpdate('typeFinalization', $event)" />
          <NxInputDateRangeAtendimento
            :limitToFifteenDays="true"
            label="Data de Finalização:"
            @update:InitialValue="handleInputDateUpdate('startDate', $event, false)"
            @update:FinalValue="handleInputDateUpdate('endDate', $event, false)"
          />
          <NxInputDateRangeAtendimento
            label="Data Abertura Protocolo:"
            @update:InitialValue="handleInputDateUpdate('protocolStartDate', $event, false)"
            @update:FinalValue="handleInputDateUpdate('protocolEndDate', $event, false)"
          />
        </div>
      </SearchCollapse>
      <div class="text-right mt-3">
        <button type="button" class="btn btn-third btn-sm" @click="openSendExcelModal">
          <i class="fas fa-file-excel"></i> Enviar Excel
        </button>
      </div>
    </SidebarSearch>
    <SendExcelModal ref="sendExcelModal" />
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import { NxSelectPAAtendimento, NxSelectTipoFinalizacao, NxSelectResponsavelAtendimento } from '@/components/nexum/components/custom-selects/index.js'
import { NxInputName, NxInputClientWApp, NxInputDateRangeAtendimento, NxInputProtocolsWApp } from '@/components/nexum/components/custom-inputs/index.js'
import toogleswitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'
import SendExcelModal from '@/views/private/atendimento/relatorios_atendimento/modal/SendExcel'

export default {
  name: 'SidebarQuadro',
  components: { SidebarSearch, SearchCollapse, NxSelectPAAtendimento, NxInputName, NxInputClientWApp, NxSelectTipoFinalizacao, toogleswitch, NxSelectResponsavelAtendimento, NxInputDateRangeAtendimento, NxInputProtocolsWApp, SendExcelModal },
  data () {
    return {
      form: {
        name: null,
        deptoId: null,
        identifier: null,
        typeFinalization: null,
        startDate: null,
        endDate: null,
        operatorId: null,
        page: 1,
        pageSize: 10,
        status: 'Finalizado',
        origemAtendimento: 'all',
        botId: null,
        botIdExclude: null,
        centralStartDate: null,
        centralEndDate: null,
        protocols: null,
        protocolStartDate: null,
        protocolEndDate: null
      }
    }
  },
  computed: {
    origemOptions () {
      return [
        { text: 'Todos', value: 'all' },
        { text: 'Campanha', value: 'campanha' },
        { text: 'Orgânico', value: 'organico' }
      ]
    },
    statusValue: {
      get () {
        return this.form.status === 'Aberto'
      },
      set (value) {
        this.form.status = value ? 'Aberto' : 'Finalizado'
      }
    }
  },
  methods: {
    normalizeCentralDateFilters () {
      if (!this.form.centralStartDate && !this.form.centralEndDate) {
        return
      }

      this.form.protocolStartDate = this.form.centralStartDate || this.form.protocolStartDate
      this.form.protocolEndDate = this.form.centralEndDate || this.form.protocolEndDate

      if (this.form.origemAtendimento === 'campanha' || this.form.origemAtendimento === 'organico') {
        this.form.status = null
      }
    },
    normalizeOrigemFilters () {
      if (this.form.origemAtendimento === 'campanha') {
        this.form.botId = ['campanha']
        this.form.botIdExclude = null
      } else if (this.form.origemAtendimento === 'organico') {
        this.form.botId = null
        this.form.botIdExclude = ['campanha']
      } else {
        this.form.botId = null
        this.form.botIdExclude = null
      }
    },
    submitForm () {
      this.normalizeOrigemFilters()
      this.normalizeCentralDateFilters()
      this.$nextTick(() => {
        this.$emit('search', { ...this.form })
        this.$emit('update-pagination')
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.form = {
        name: null,
        deptoId: null,
        identifier: null,
        typeFinalization: null,
        startDate: null,
        endDate: null,
        operatorId: null,
        page: 1,
        pageSize: 10,
        status: 'Finalizado',
        origemAtendimento: 'all',
        botId: null,
        botIdExclude: null,
        centralStartDate: null,
        centralEndDate: null,
        protocols: null,
        protocolStartDate: null,
        protocolEndDate: null
      }
      this.$nextTick(() => {
        this.submitForm()
        this.page = 1
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    handleSelectUpdate (fieldName, selectedValue) {
      if (typeof selectedValue === 'string' || typeof selectedValue === 'number') {
        this.form[fieldName] = [selectedValue]
        return
      }
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue) ? selectedValue.map(v => v.value) : [selectedValue.value]
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        this.form[fieldName] = inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdateArray (fieldName, inputedValue) {
      if (inputedValue) {
        this.form[fieldName] = [inputedValue]
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputDateUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        // Parse a data no formato UTC para evitar problemas de timezone
        const date = new Date(inputedValue + 'T00:00:00.000Z')

        if (fieldName === 'endDate' || fieldName === 'protocolEndDate') {
          // Para data final, ajusta para 23:59:59.999 UTC
          date.setUTCHours(23, 59, 59, 999)
        } else {
          // Para data inicial, mantém 00:00:00.000 UTC
          date.setUTCHours(0, 0, 0, 0)
        }

        this.form[fieldName] = date.toISOString()
      } else {
        this.clearField(fieldName)
      }
    },
    openSendExcelModal () {
      this.$refs.sendExcelModal.openModal(this.form) // Passa os filtros para o modal
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/relatorios_atendimento/search/SidebarRelatorioAtendimento.vue